import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Autocomplete from 'react-autocomplete';
import CustomCheckbox from '../NuevaFichaVenta/CustomCheckbox';
import Modal from '../../../components/Modal';
import Steps from '../../../components/Steps';
import ConfirmarInformacion from './ConfirmarInformacion';
import Notificacion from './Notificacion';
import addSolicitudExcep from '../../../utils/addSolicitudExcep';
import { fetchTipoAutorizacion,
  fetchResponsables,
  fetchPedidos,
  fetchSolicitudPedidos,
  fetchColaboradores,
  clearColaboradores,
  saveGenerarCorreoAutorizaciones } from '../../../actions';
import validators from './validators';
import { initializeValidators,
  resetValidators,
  displayValidationErrors,
  isFormValid } from '../../../utils/validateForm';

const TIPO_RESPONSABLE_REGULARIZACION = 'R';
const VACIO = '';

const Pills = props => (
  <div className='pillSelct mb-3'>
    <ul className='pillSelct-pills'>
      {
        props.pedidos.map((pedido,index) => (
          <li className='pill pill-cyan pillSelct-pills-item' key={index}>
            {pedido.numPedidoVeh}
            <button
              type='button'
              className='pillSelct-delete'
              onClick={(e) => props.unselectPedido(e, {pedido})}>
              <i className='icon ion-close pill-close' />
            </button>
          </li>
        ))
      }
    </ul>
  </div>
);

const Pedidos = props => (
  <div className='form-group'>
    <div className='row'>
      <div className='col-xs-12 col-sm-6'>
        <label className='labelInfo' htmlFor='tipo-sol'>Pedidos</label>
        <div className='dropdown dropdown-multi customToggle' id='pedidos'>
          <div className='dropdown-control'>
            <input className='dropdown-control-input' placeholder='Pedidos' />
            <div className='dropdown-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
          <div className='dropdown-tooltip dropdown-menu'>
            <div className='dropdown-scroll'>
              <ul>
                {
                  props.fichaVentaPedidos.map((pedidos,index) => (
                    <li key={index}>
                      <CustomCheckbox
                        id={pedidos.numPedidoVeh}
                        label={pedidos.numPedidoVeh}
                        name='pedido'
                        onChange={props.onCheck}
                        isChecked={props.numPedidoVeh}
                      />
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Pills pedidos={props.solicitudPedidos} unselectPedido={props.unselectPedido} />
    { props.displayValidationErrors(props.validators, 'pedidos') }
  </div>
);

class SolExcep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      step:1,
      codSolicitud:0,
      tipoSolicitud:'',
      descTipoSolicitud:'',
      nvehi:0,
      obsExcep:'',
      fechaExcep:null,
      responsable:'',
      responsableID:'',
      showPedido:false,
      fichaVentaPedidos:[],
      solicitudPedidos:[],
      pedidos:[],
      numPedidoVeh:'',
      isFormValided:false,
      colaborador: '',
      colaboradores: []
    };

    this.baseState = this.state;
    this.validators = validators;
    this.solicitudSeleccionada = this.props.excepcion;
    this.hasSolicitud = !(typeof(this.solicitudSeleccionada) === 'undefined');
    this.title = this.hasSolicitud?'Editar Autorización':'Nueva Autorización';
    this.textButton = this.hasSolicitud?'Editar sol. excepcional':'Crear sol. excepcional';
    this.action = this.hasSolicitud?'actualizada':'registrada';

    resetValidators(this.validators);
    fetchTipoAutorizacion();
    this.props.fetchResponsables(TIPO_RESPONSABLE_REGULARIZACION);
    fetchPedidos(this.props.fdvID);
  }

  componentDidMount() {
    if(this.hasSolicitud) {
      this.props.fetchSolicitudPedidos(this.solicitudSeleccionada.codSolicitud).then((results) => {
        this.setState({
          codSolicitud:this.solicitudSeleccionada.codSolicitud,
          fichaVentaPedidos:this.props.fichaVentaPedidos
            .filter(fichaVentaPedido => !this.existsPedido(this.props.solicitudPedidos,fichaVentaPedido)),
          solicitudPedidos:this.props.solicitudPedidos,
          pedidos:this.props.solicitudPedidos
            .map(solicitudPedido => solicitudPedido.numPedidoVeh),
          tipoSolicitud:this.solicitudSeleccionada.codTipoAutExcepcional,
          descTipoSolicitud:this.solicitudSeleccionada.desTipoAutExcepcional,
          showPedido:(this.solicitudSeleccionada.numPedidosVeh!==null),
          nvehi:parseInt(this.solicitudSeleccionada.canVehiculos,0),
          obsExcep:this.solicitudSeleccionada.obsSolicitud,
          fechaExcep:moment(this.solicitudSeleccionada.fecEstimadaRegul,'DD/MM/YYYY'),
          responsableID:this.solicitudSeleccionada.codUsuarioRegul,
          responsable:this.props.responsables
            .filter(({txtUsuario}) => txtUsuario === this.solicitudSeleccionada.codUsuarioRegul)[0].nombreCompleto,
        });
        let promise = new Promise((resolve, reject) => {
          initializeValidators(this.validators,
            this.state,
            true,
            [(this.solicitudSeleccionada.numPedidosVeh!==null?'nvehi':'pedidos')]);
          resolve();
        });
        promise.then(result => {
          this.onChangeFormValidation();
        });
      })
    } else {
      this.setState({fichaVentaPedidos:this.props.fichaVentaPedidos});
    }
  }

  existsPedido = (listado,pedido) => {
    return (typeof(listado.find(e => e.numPedidoVeh === pedido.numPedidoVeh))!=='undefined');
  }

  handleInputChange = (e, field, exclude) => {
    const validator = this.validators[field];
    validator.state = (e !== null ? e.target.value : '');
    validator.exclude = (typeof(exclude) === 'undefined' || exclude === null ? false : exclude);
    this.onChangeFormValidation();
  }

  onChangeFormValidation = () => {
    this.setState({isFormValided:isFormValid(this.validators)});
  }

  onChangeValue = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onChangeObservaciones = e => {
    this.onChangeValue(e);
    this.handleInputChange(e, 'obsExcep');
  }

  onChangeResponsable = e => {
    if (e.target.value.length >= 2) {
      this.props.fetchResponsables(TIPO_RESPONSABLE_REGULARIZACION,e.target.value);
    }
    if (e.target.value.length === 0) {
      this.setState({ responsable: '' });
    }
    this.setState({ responsable: e.target.value })
    this.handleInputChange(e, 'responsable');
  };

  onChangeShowPedido = e => {
    const indPedido = e.target.options[e.target.selectedIndex].dataset.indpedido;
    this.setState({showPedido:(indPedido==='S')});
    this.handleInputChange(e, 'tipoSolicitud');
    const { nvehi, pedidos } = this.state;
    e.target['value'] = pedidos;
    this.handleInputChange(e, 'pedidos', !(indPedido==='S'));
    e.target['value'] = nvehi;
    this.handleInputChange(e, 'nvehi', !(indPedido==='N'));
  }

  onCheck = (e) => {
    let newSolicitudPedidos = this.state.solicitudPedidos.slice();
    newSolicitudPedidos.push({numPedidoVeh:e.target.value});
    this.setState({solicitudPedidos:newSolicitudPedidos});
    let newPedidos = this.state.pedidos.slice();
    newPedidos.push(e.target.value);
    this.setState({pedidos:newPedidos});
    this.setState({
      fichaVentaPedidos:this.state.fichaVentaPedidos
        .filter(pedido => pedido.numPedidoVeh !== e.target.value)
    });
    e.target['value'] = newPedidos;
    this.handleInputChange(e, 'pedidos');
  }

  prevStep = () => {
    this.setState({ step: this.state.step - 1 });
  }

  nextStep = () => {
    this.setState({ step: this.state.step + 1 });
  }

  unselectPedido = (e, obj) => {
    let newFichaVentaPedidos = this.state.fichaVentaPedidos.slice();
    newFichaVentaPedidos.push({numPedidoVeh:obj.pedido.numPedidoVeh});
    this.setState({fichaVentaPedidos:newFichaVentaPedidos});
    this.setState({
      solicitudPedidos:this.state.solicitudPedidos
        .filter(pedido => pedido.numPedidoVeh !== obj.pedido.numPedidoVeh)
    });
    let newPedidos = this.state.pedidos
      .filter(pedido => pedido !== obj.pedido.numPedidoVeh);
    this.setState({pedidos:newPedidos});
    e.target['value'] = newPedidos;
    this.handleInputChange(e, 'pedidos');
  }

  changeResponsables = (e) => {
    this.setState({
      descTipoSolicitud: this.props.tipos
        .find(tipo => tipo.codTipoAutorizacionExcep === e.target.value).descripcion
    });
    this.onChangeValue(e);
    this.props.fetchResponsables(TIPO_RESPONSABLE_REGULARIZACION);
    this.onChangeShowPedido(e);
  }

  handleFechaExcep = date => {
    if(date!==null){
      date['target'] = {value:date};
    }
    this.setState({ fechaExcep: date });
    this.handleInputChange(date, 'fechaExcep');
  }

  increment = (e) => {
    let increment = this.state.nvehi + 1;
    this.setState({ nvehi: increment })
    e.target['value'] = increment;
    this.handleInputChange(e, 'nvehi');
  }

  decrement = (e) => {
    if (this.state.nvehi > 0) {
      let decrement = this.state.nvehi - 1;
      this.setState({ nvehi: decrement });
      e.target['value'] = decrement;
      this.handleInputChange(e, 'nvehi');
    }
  }

  selectResponsable = (key) => {
    this.setState({
      responsableID: this.props.responsables
        .filter(({ codIdUsuario }) => codIdUsuario === key)[0].txtUsuario,
      responsable: this.props.responsables
        .filter(({ codIdUsuario }) => codIdUsuario === key)[0].nombreCompleto,
    });
    const event = Object.assign({}, this.state);
    event['target'] = {value:key};
    this.handleInputChange(event, 'responsable');
  };

  addSolicitud = () => {
    const { fdvID, fichaVenta } = this.props;
    const { codSolicitud,
      tipoSolicitud,
      nvehi,
      obsExcep,
      fechaExcep,
      responsableID,
      pedidos } = this.state;
    addSolicitudExcep(codSolicitud,
      fichaVenta,
      nvehi,
      tipoSolicitud,
      responsableID,
      fechaExcep,
      obsExcep,
      pedidos)
      .then(({ data }) => {
        this.props.openAlert(data);
        if (data.estadoTrama === '1') {
          const codSolicitud = this.hasSolicitud
            ?this.solicitudSeleccionada.codSolicitud
            :data.codigo;
          this.setState({codSolicitud:codSolicitud});
          this.nextStep();
          this.props.fetchAutorizacionesExcepcionales(fdvID);
          this.generarCorreo({codSolicitud:codSolicitud,
                  numFichaVtaVeh:fichaVenta.numFichaVtaVeh,
                  numProfVeh:'',
                  codEstadoAut:(this.hasSolicitud?this.solicitudSeleccionada.codEstadoAut:'P')});
        }
      });
  }

  validateForm = () => {
    if(this.state.isFormValided) {
      this.nextStep();
    }
    this.onChangeFormValidation();
  }

  changeColaborador = (e) => {
    this.onChangeValue(e);
    if (e.target.value.length >= 2) {
      this.props.fetchColaboradores(e.target.value);
    } else if (e.target.value.length === 0) {
      this.props.clearColaboradores();
    }
  }

  selectColaborador = (key) => {
    const { colaboradores } = this.state;
    const colaboradorSelected = colaboradores.filter(colaborador => colaborador.id === key).length;

    if (!colaboradorSelected) {
      const nombres = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].nombre;

      const apellidos = this.props.colaboradores
      .filter(({ idUsuario }) => idUsuario.toString() === key)[0].apellidos;
      const colaborador = { id: key, nombres: `${apellidos} ${nombres}` };

      this.setState({ colaborador: '', colaboradores: [...this.state.colaboradores, colaborador] });
      this.props.clearColaboradores();
    }
  }

  removeColaborador = (id) => {
    const { colaboradores } = this.state;
    this.setState({ colaboradores: colaboradores.filter(colaborador => id !== colaborador.id) });
  }

  generarCorreo = (excepcion) => {
    const { colaboradores } = this.state;
    let colaboradoresSelected = colaboradores.map((colaborador) => colaborador.id).toString();
    if(typeof(colaboradoresSelected) !== 'undefined' &&
      colaboradoresSelected !== null &&
      colaboradoresSelected !== '') {
      this.props.saveGenerarCorreoAutorizaciones(
        excepcion.codSolicitud,
        excepcion.numFichaVtaVeh,
        excepcion.numProfVeh,
        excepcion.codEstadoAut,
        colaboradoresSelected,//destinatarios
        VACIO,
        VACIO).then((result) => {
          const response = result.payload.data;
          this.props.openAlert(response);
      });
    }
  }

  render() {
    const { step,
      tipoSolicitud,
      nvehi,
      obsExcep,
      fechaExcep,
      responsable } = this.state;
    const stepsTitle = ['Ingresar Información de Solicitud', 'Confirmar Información'];
    return (
      <Modal title={this.title}
        idModal='fdv-solExcep'
        closeModal={this.props.closeModal}
        isOpen modalSize=''>
        <div className='modalBleed'>
          <Steps stepsTitle={stepsTitle} step={step} />
        </div>
        <div className='steps-container fdvNew-slides'>
          {
            step === 1 &&
              <form>
                <div className='form-group'>
                  <div className='row'>
                    <div className='col-xs-12 col-sm-6'>
                      <label className='labelInfo' htmlFor='tipo-sol'>Tipo de solicitud</label>
                      <div className='select'>
                        <select id='tipo-sol'
                          className='form-control'
                          name='tipoSolicitud'
                          value={tipoSolicitud}
                          onChange={this.changeResponsables}>
                          <option value='' disabled>Selecciona tipo de solicitud</option>
                          {
                            this.props.tipos.map(tipo =>
                              <option
                                value={tipo.codTipoAutorizacionExcep}
                                key={tipo.codTipoAutorizacionExcep}
                                data-indpedido={tipo.indPedido}
                              >
                                {tipo.descripcion}
                              </option>
                            )
                          }
                        </select>
                        <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                      </div>
                    </div>
                  </div>
                  { displayValidationErrors(this.validators, 'tipoSolicitud') }
                </div>
                {
                  !this.state.showPedido &&
                    <div className='form-group'>
                      <div className='stepper'>
                        <label className='stepper-label' htmlFor='vehi-sol'>N° de Vehículos</label>
                        <div className='stepper-control'>
                          <i name="decrement"
                            className='ion-android-remove stepper-control-minus'
                            onClick={e => this.decrement(e)} />
                          <input className='stepper-control-number valid'
                            value={nvehi}
                            readOnly
                            min='0'
                            name='nvehi'
                            id='vehi-sol' />
                          <i name="increment"
                            className='ion-android-add stepper-control-plus'
                            onClick={e => this.increment(e)} />
                        </div>
                        <label className='error' generated='true' htmlFor='nvehi' />
                      </div>
                      { displayValidationErrors(this.validators, 'nvehi') }
                    </div>
                }
                {
                  this.state.showPedido &&
                    <Pedidos
                      solicitudAutExcep={this.state}
                      fichaVentaPedidos={this.state.fichaVentaPedidos}
                      solicitudPedidos={this.state.solicitudPedidos}
                      unselectPedido={this.unselectPedido}
                      onCheck={this.onCheck}
                      numPedidoVeh={this.state.numPedidoVeh}
                      validators={this.validators}
                      displayValidationErrors={displayValidationErrors}
                    />
                }
                <div className='form-group'>
                  <div className='form-group'>
                    <label className='labelInfo' htmlFor='obs-sol'>Observaciones</label>
                    <textarea className='form-control'
                      name='obsExcep'
                      id='obs-sol'
                      value={obsExcep}
                      onChange={this.onChangeObservaciones} />
                  </div>
                  { displayValidationErrors(this.validators, 'obsExcep') }
                </div>
                <div className='form-group'>
                  <div className='row'>
                    <div className='col-xs-12 col-sm-6'>
                      <div className='datepicker'>
                        <label className='datepicker-label' htmlFor='fecha-sol'>Fecha estimada de regularización</label>
                        <DatePicker
                          selected={fechaExcep}
                          className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched'
                          dateFormat='DD/MM/YYYY'
                          locale='es'
                          onChange={this.handleFechaExcep}
                          placeholderText='Fecha estimada'
                        />
                      </div>
                      { displayValidationErrors(this.validators, 'fechaExcep') }
                    </div>
                  </div>
                </div>
                <hr />
                <div className='row'>
                  <div className='col-xs-12 col-sm-6'>
                    <label className='labelInfo' htmlFor='responsable'>Responsable de regularización</label>
                    <Autocomplete
                      inputProps={{
                        className: 'form-control',
                        placeholder: 'Ingrese un nombre',
                      }}
                      wrapperStyle={{
                        display: 'inline-block',
                        position: 'relative',
                        zIndex: '10',
                      }}
                      menuStyle={{
                        position: 'absolute',
                        left: '0',
                        top: '100%',
                        maxHeight: '350px',
                        overflow: 'auto',
                        border: '1px solid #cccccc',
                      }}
                      name='responsable'
                      items={this.props.responsables}
                      getItemValue={item => item.codIdUsuario}
                      renderItem={(item, isHighlighted) =>
                          <div key={item.codIdUsuario}
                            style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                            {item.nombreCompleto}
                          </div>
                        }
                      onChange={(e) => this.onChangeResponsable(e)}
                      onSelect={key => this.selectResponsable(key)}
                      value={responsable}
                    />
                    { displayValidationErrors(this.validators, 'responsable') }
                  </div>
                </div>
                <div className='modal-actions'>
                  <button className='btn btn-primary pull-right'
                    type='button'
                    onClick={this.validateForm}>Siguiente</button>
                </div>
              </form>
          }
          {
            step === 2 &&
              <ConfirmarInformacion
                prevStep={this.prevStep}
                addSolicitud={this.addSolicitud}
                textButton={this.textButton}
                fichaVenta={this.props.fichaVenta}
                solicitud={this.state}
                changeColaborador={this.changeColaborador}
                selectColaborador={this.selectColaborador}
                removeColaborador={this.removeColaborador}
                colaboradores={this.props.colaboradores}
                colaborador={this.state.colaborador}
                colaboradoresSeleccionados={this.state.colaboradores}
              />
          }
          {
            step === 3 &&
              <Notificacion
                codSolicitud={this.state.codSolicitud}
                colaboradoresSeleccionados={this.state.colaboradores}
                action={this.action}
              />
          }
        </div>
      </Modal>
    );
  }
}

SolExcep.defaultProps = {
  tipos: [],
  responsables: [],
  fichaVentaPedidos:[],
  solicitudPedidos:[],
  colaboradores:[]
};

function mapStateToProps(state) {
  return {
    tipos: state.tipoAutorizacion,
    responsables: state.responsables,
    fichaVentaPedidos:state.pedidos,
    solicitudPedidos:state.solicitudPedidos,
    colaboradores: state.colaboradores
  };
}

export default withRouter(
  connect(mapStateToProps, {
    fetchTipoAutorizacion,
    fetchResponsables,
    fetchPedidos,
    fetchSolicitudPedidos,
    fetchColaboradores,
    clearColaboradores,
    saveGenerarCorreoAutorizaciones
  })(SolExcep));



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitudExcepcional/index.js